import React, { useEffect, useState } from "react";
import ButtonBot from "shared/components/ButtonBot";
import AppInfoRow from "shared/components/AppInfoRow";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getParkingSpaceUsingList } from "../usecases/ParkingUsecases";
import {datetimeFormat, getFormattedTime, isDuplicateEntryIdAtIndex, numberFormat, makeCenterLine, makeFixedLine, formatMinutesToTime} from "../../../utils/common";
import Popup from "shared/components/Popup";
import { setAppLoading } from "../../../shared/store/headerSlice";
import { checkFeeOutTime, getParkingOperateTime, onPaymentFee, recognition, setUnpaidCustom } from "../usecases/CarInOutUsecases";
import Skeleton from 'react-loading-skeleton';
import { RotatingLines } from 'react-loader-spinner';
import { DateTime } from "luxon";
import { toast } from "react-toastify";
import AppInfiniteScroll from "../../../shared/components/AppInfiniteScroll";
import { setUser } from "../../auth/presentation/store/authSlice";
import { getServerTime } from "../../auth/usecases/AuthUsecases";
import { onGetParkingTid } from "../utils/parkingUtils";

const ParkingClosing = () => {
  const [parkingSpaceUsingList, setParkingSpaceUsingList] = useState([]);
  const [cardPayAmount, setCardPayAmount] = useState(0);
  const [showPopupConfirmUnpaid, setShowPopupConfirmUnpaid] = useState(false);
  const [showPopupConfirmUnpaidPast, setShowPopupConfirmUnpaidPast] = useState(false);
  const [showPopupError, setShowPopupError] = useState(false);
  const [pageLoading, setPageLoading] = useState(1);
  const [unpaidLoading, setUnpaidLoading] = useState(false);
  const [unpaidLoadingProgress, setUnpaidLoadingProgress] = useState("0%");
  const [showPopupNoData, setShowPopupNoData] = useState(false);
  const [showPopupNice, setShowPopupNice] = useState(false);
  const [totalPayAmount, setTotalPayAmount] = useState(0);
  const [payCount, setPayCount] = useState(0);
  const [showPopupAlert, setShowPopupAlert] = useState(false);
  const [closingTime, setClosingTime] = useState("");
  const [currentTime, setCurrentTime] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, serverTime, dayType } = useSelector((state) => state.auth);
  const { parkingSpots } = useSelector((state) => state.parking);


  const fetchParkingSpace = async () => {
    try {
      const data = await getParkingSpaceUsingList({ parkingId: user.parkingId });
      if (data) {
        setParkingSpaceUsingList(data?.entryList || []);
        const cardPayAmount = data?.entryList?.reduce((acc, entry) => {
          if (entry?.payWayCd === "020") {
            return acc + (entry?.amount || 0);
          }
          return acc;
        }, 0) || 0;
        setCardPayAmount(cardPayAmount);

        let unPaidCount = 0;
        let prePaidCount = 0;
        let pastUnPaidCount = 0;

        data?.entryList?.map((acc, index) => {
          const duplicateIndex = data?.entryList.findIndex((otherItem, otherIndex) =>
            otherIndex !== index && otherItem.carNum == acc.carNum
          );
          if (acc.outTime >= getFormattedTime(serverTime) && ((acc.payStatusCd == "030" && acc?.unpaid?.statusCd == "020") || acc.payStatusCd == "020")) {
            if (duplicateIndex > index || duplicateIndex == -1) {
              prePaidCount++;
            }

          } else {

            if (duplicateIndex > index || duplicateIndex == -1) {
              unPaidCount++;
              let inDate = DateTime.fromFormat(acc.inTime, "yyyyMMddHHmmss").toFormat("yyyyMMdd");
              let currentDate = getFormattedTime(serverTime, "yyyyMMdd");

              if (inDate < currentDate) {
                pastUnPaidCount++;
              }

            }
          }
        })

        setPayCount({
          unPaidCount: unPaidCount,
          prePaidCount: prePaidCount,
          pastUnPaidCount: pastUnPaidCount,
        });

        const totalPayAmount = data?.paymentList?.reduce((acc, entry) => {
          return acc + (entry?.amount || 0);
        }, 0) || 0;
        setTotalPayAmount(totalPayAmount);

        console.log("Parking space data:", data);
      } else {
        console.error("No parking space data found.");
      }
    }
    catch (error) {
      console.error("Error fetching parking space list:", error);
    } finally {
      setPageLoading(prev => prev + 1);
    }
  }

  useEffect(() => {
    fetchParkingSpace();
  }, []);

  const handleYes = () => {
    navigate("/menu_manager");
  };

  const handleNo = () => {
    navigate("/menu_manager");
  };

  function isDoubleEntryIdAtIndex(arr, index) {
    const targetId = arr[index]?.entryId;
    if (targetId == undefined || !arr[index]?.entryId) return false;

    let extraSpace = arr.some((item, i) => i !== index && item.entryId == targetId);
    let isDouble = arr.some((item, i) => i < index && i != index && item.entryId == targetId);
    return {
      extraSpace,
      isDouble
    }
  }

  const onUnpaid = async (handleType = "today") => {

    setShowPopupConfirmUnpaid(false);
    setShowPopupConfirmUnpaidPast(false);
    setUnpaidLoading(true);
    try {
      let index = 0;

      for (const item of parkingSpaceUsingList) {

        let weekdayHours = user?.parking?.weekdayOperatingHours;

        if (dayType == 'WEEKEND' && user?.parking?.weekendOperatingHours) {
          weekdayHours = user?.parking?.weekendOperatingHours;
        } else if (dayType == 'HOLIDAY' && user?.parking?.holidayOperatingHours) {
          weekdayHours = user?.parking?.holidayOperatingHours;
        }

        if (!weekdayHours) return;

        const [beginStr, endStr] = weekdayHours.split("~").map(t => t.trim());
        const [workingEndHour, workingEndMinute] = endStr.split(":");

        const validate = isDoubleEntryIdAtIndex(parkingSpots, parseInt(item?.spaceNumber) - 1)

        //handle old entries
        let inDate = DateTime.fromFormat(item.inTime, "yyyyMMddHHmmss").toFormat("yyyyMMdd");
        let currentDate = getFormattedTime(serverTime, "yyyyMMdd");

        //handle past entries
        let pastDay = DateTime.fromFormat(item.inTime, "yyyyMMddHHmmss").toFormat("dd");
        let pastMonth = DateTime.fromFormat(item.inTime, "yyyyMMddHHmmss").toFormat("MM");
        let pastYear = DateTime.fromFormat(item.inTime, "yyyyMMddHHmmss").toFormat("yyyy");

        let unpaidHours;
        if (handleType == 'today' && inDate == currentDate) {
          unpaidHours = serverTime?.set({
            hour: workingEndHour,
            minute: workingEndMinute,
            second: 0,
            millisecond: 0
          });

        } else if (handleType == 'past' || inDate < currentDate) {
          unpaidHours = serverTime?.set({
            year: pastYear,
            month: pastMonth,
            day: pastDay,
            hour: workingEndHour,
            minute: workingEndMinute,
            second: 0,
            millisecond: 0
          });

        }

        if (handleType == 'past' && inDate < currentDate && !validate?.isDouble) {
          setPayCount(prev => {
            return {
              ...prev,
              pastUnPaidCount: 0
            }

          })
          await onUnpaidOne(item, 'past');
        } else {

          const response = await checkFeeOutTime({
            parkingId: user.parkingId,
            carNumber: item.carNum,
            facilityId: "00003",
            outTime: unpaidHours,
            extraSpace: validate?.extraSpace || false
          });

          const ignorePayStatusCd = ["020", "030"];


          if (!item.outTime && response?.fee?.feeFinal >= 100 && !validate?.isDouble && !ignorePayStatusCd.includes(item.payStatusCd)) {
            if (inDate < currentDate) {
              await onUnpaidOne(item, 'past');
            } else if (handleType == 'today') {
              await onUnpaidOne(item);
            }

            await onBillPrint(response);

          } else if (!validate?.isDouble && !item.outTime && handleType == 'today' && response?.fee?.feeFinal < 100 && !ignorePayStatusCd.includes(item.payStatusCd)) {
            const data = {
              parkingId: user.parkingId,
              facilityId: item?.spaceNumber?.toString().padStart(5, "0") || "00001",
              facilityKind: "LPR_OUT",
              angle: "MAIN",
              recognitionId: "11",
              carNumber: item.carNum,
              dateTime: unpaidHours,
              payStationId: "MOBILE",
              userId: user.userId,
            }
            
            await onPaymentFee({
              ...data,
              payWay: "CASH",
              payStationId: user.userId,
              price: 0,
              payTime: unpaidHours,
              entryList: [
                {
                  payType: "PARKING_FEE",
                  parkingEntryId: "",
                  membershipApplicantId: "",   // 정기권ID
                  extendedMonths: 0,           // 정기권 연장 달수
                }
              ],

            });
            await recognition(data);
          }

        }


        index++;
        setUnpaidLoadingProgress(() => {
          const progress = Math.floor((index / parkingSpaceUsingList.length) * 100);
          return progress + "%";
        });

      }

      fetchParkingSpace(); // Refresh the parking space list after processing unpaid
    }
    catch (error) {

      console.error("Error during unpaid processing:", error);
      setShowPopupError(true);
    } finally {
      setUnpaidLoadingProgress(0);
      setUnpaidLoading(false);
      toast.success('완료되었습니다.', {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: 'htToastSuccess',
      });
    }
  };

  const onUnpaidOne = async (item, handleType = 'today') => {

    try {
      let _dayType = dayType;

      const getServerTimeApi = await getServerTime({
        dateTime: item.inTime
      });

      if (getServerTimeApi?.dayType) {
        _dayType = getServerTimeApi?.dayType;
      }

      let weekdayHours = user?.parking?.weekdayOperatingHours;

      if (_dayType == 'WEEKEND' && user?.parking?.weekendOperatingHours) {
        weekdayHours = user?.parking?.weekendOperatingHours;
      } else if (_dayType == 'HOLIDAY' && user?.parking?.holidayOperatingHours) {
        weekdayHours = user?.parking?.holidayOperatingHours;
      }

      if (!weekdayHours) return;

      const [beginStr, endStr] = weekdayHours.split("~").map(t => t.trim());
      const [workingEndHour, workingEndMinute] = endStr.split(":");

      //handle past entries
      let pastDay = DateTime.fromFormat(item.inTime, "yyyyMMddHHmmss").toFormat("dd");
      let pastMonth = DateTime.fromFormat(item.inTime, "yyyyMMddHHmmss").toFormat("MM");
      let pastYear = DateTime.fromFormat(item.inTime, "yyyyMMddHHmmss").toFormat("yyyy");

      let serverHours;
      if (handleType == 'today') {
        serverHours = serverTime?.set({
          hour: workingEndHour,
          minute: workingEndMinute,
          second: 0,
          millisecond: 0
        });

      } else if (handleType == 'past') {
        serverHours = serverTime?.set({
          year: pastYear,
          month: pastMonth,
          day: pastDay,
          hour: workingEndHour,
          minute: workingEndMinute,
          second: 0,
          millisecond: 0
        });

      }

      const response = await setUnpaidCustom({
        parkingId: user.parkingId,
        facilityId: "00003",
        carNumber: item.carNum,
        outTime: serverHours.toISO(),
      });
      console.log("Unpaid Response:", response);



    } catch (error) {
      console.error("Error during unpaid:", error);
    }
  }

  const refreshFunction = async () => {
    setPageLoading(1);
    fetchParkingSpace();
  }

  const onParkingClosing = async (handleType) => {
    try {
      if (parkingSpaceUsingList.length === 0) {
        setShowPopupNoData(true);
        return;
      }
      dispatch(setAppLoading(true));
      const getServerTimeApi = await getServerTime();
      const response = await getParkingOperateTime({
        parkingId: user.parkingId,
      });
      let weekdayHours = response?.weekdayOperatingHours;

      if (dayType == 'WEEKEND' && response?.weekendOperatingHours) {
        weekdayHours = response?.weekendOperatingHours;
      } else if (dayType == 'HOLIDAY' && response?.holidayOperatingHours) {
        weekdayHours = response?.holidayOperatingHours;
      }

      if (!weekdayHours) return;

      dispatch(setUser({
        ...user,
        parking: {
          ...user.parking,
          weekdayOperatingHours: response?.weekdayOperatingHours,
          weekendOperatingHours: response?.weekendOperatingHours,
          holidayOperatingHours: response?.holidayOperatingHours,
        }
      }))

      // let weekdayHours = user?.parking?.weekdayOperatingHours;

      // if (dayType == 'WEEKEND' && user?.parking?.weekendOperatingHours) {
      //   weekdayHours = user?.parking?.weekendOperatingHours;
      // } else if (dayType == 'HOLIDAY' && user?.parking?.holidayOperatingHours) {
      //   weekdayHours = user?.parking?.holidayOperatingHours;
      // }
      const serverTime = DateTime.fromISO(
        getServerTimeApi?.ISO || DateTime.now().setZone('Asia/Seoul').toISO(),
        { setZone: true }
      );

      if (!serverTime.isValid) {
        setShowPopupError(true);
        dispatch(setAppLoading(false));
      }

      const [beginStr, endStr] = weekdayHours.split("~").map(t => t.trim());
      const serverHours = getFormattedTime(serverTime, "HH:mm").toString();


      setClosingTime(endStr);
      setCurrentTime(serverHours);

      const endTime = DateTime.fromFormat(endStr, "HH:mm").toFormat("HH:mm").toString();

      if (serverHours < endTime && handleType == 'today') {
        setShowPopupAlert(true);
        return;
      } else {
        if (payCount.unPaidCount === 0) {
          setShowPopupNoData(true);
          return;
        } else if (handleType == 'today') {
          setShowPopupConfirmUnpaid(true)
        } else if (handleType == 'past') {
          setShowPopupConfirmUnpaidPast(true)
        }

      }
    } catch (error) {
      console.error("Error fetching parking operate time:", error);
      setShowPopupError(true);
    } finally {
      dispatch(setAppLoading(false));
    }

  }

  const onBillPrint = async (res) => {

    let title = '미납증';

    const encoder = new TextEncoder(); // 기본 utf-8

    let form = [
      0x0A,
      0x1B, 0x40, //명령 초기화

      0x1D, 0x21, 0x11,   // 크기 크게
      ...encoder.encode(makeCenterLine(title, true)), 0x0A,
      0x1D, 0x21, 0x00,   // 크기 초기화

      0x1B, 0x61, 0x02,   // 우측 정렬
      ...encoder.encode('No:' + (window.APP_CONFIG?.parkingSeq || '000010')), 0x0A,
      0x1B, 0x61, 0x00,   // 왼쪽 정렬

      0x1D, 0x21, 0x11,   // 크기 크게
      ...encoder.encode('-'.repeat(24)), 0x0A,
      0x1D, 0x21, 0x00,   // 크기 초기화
      0x0A,

      ...encoder.encode(makeFixedLine('주차장명:', user?.parking?.parkingName)), 0x0A,
      ...encoder.encode(makeFixedLine('사업자주소:', user?.parking?.address)), 0x0A,
      ...encoder.encode(makeFixedLine('전화번호:', user?.parking?.phoneNumber)), 0x0A,
      ...encoder.encode(makeFixedLine('일시:', getFormattedTime(serverTime, "yyyy-MM-dd HH:mm:ss"))), 0x0A,

      0x1D, 0x21, 0x11,   // 크기 크게
      ...encoder.encode('-'.repeat(24)), 0x0A,
      0x1D, 0x21, 0x00,   // 크기 초기화
      0x0A,

      ...encoder.encode(makeFixedLine('차량번호:', res?.fee?.carNumber)), 0x0A,
      ...encoder.encode(makeFixedLine('입차일시:', datetimeFormat(res?.fee?.inTime, "ISO", "yyyy-MM-dd HH:mm"))), 0x0A,
      ...encoder.encode(makeFixedLine('출차일시:', datetimeFormat(res?.fee?.outTime, "ISO", "yyyy-MM-dd HH:mm"))), 0x0A,
      ...encoder.encode(makeFixedLine('주차시간:', formatMinutesToTime(res?.fee?.parkingMinute))), 0x0A,
      ...encoder.encode(makeFixedLine('주차요금:', numberFormat(res?.fee?.feeCalculated))), 0x0A,

    ];

    if (Array.isArray(res?.fee?.discountDetails)) {
      res?.fee?.discountDetails.forEach((discount, idx) => {
        form.push(
            ...encoder.encode( makeFixedLine(idx === 0 ? '할인항목:' : '', discount.name)), 0x0A,
        );
      });
    }

    form.push(
      ...encoder.encode(makeFixedLine('할인금액:', '-' + numberFormat(res?.fee?.feeDiscount))), 0x0A,
      ...encoder.encode(makeFixedLine('정산금액:', numberFormat(res?.fee?.feeFinal))), 0x0A,

      0x1D, 0x21, 0x11,   // 크기 크게
      ...encoder.encode('-'.repeat(24)), 0x0A,
      0x1D, 0x21, 0x00,   // 크기 초기화
      0x0A,

      ...encoder.encode(makeCenterLine('이용해 주셔서 감사합니다.')), 0x0A

    );

    const formData = new Uint8Array(form);

    const formEnc = btoa(String.fromCharCode(...formData));

    const payKey = await onGetParkingTid(user.parkingId);

    if (!payKey || !payKey.tid) {
      setShowPopupError(true);
      return;
    }

    // print params for VAN API
    const params = new URLSearchParams({
      billType: '9',                        // 전문종류 ( 9:프린터출력 )
      terminalNo: payKey?.tid,              // 단말기 번호
      orderKey: '99999',                    // 주문번호 ( 요청/응답 명시 용도 )
      printResType: '1',
      resScheme: 'innodep://printResponse', // 응답 스키마
    });

    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "print", body: params.toString(), printForm: formEnc })
      );

      try{
        await waitForPrintRes();
      } catch (err){
        console.error('print err : ', err);
      }

    } else {
      console.error('Cannot find Native App !!');
    }

  }

  function waitForPrintRes() {
    return new Promise((resolve, reject) => {
      const responseListener = (event) => {
        const msg = JSON.parse(event.data);
        // alert(JSON.stringify(msg));
        try {
          if (msg.type === 'printRes') {
            if (['0000', '0021'].includes(msg.body.responseCode)) {
              // when print success
              resolve(msg);
            }else{
              reject(new Error('res code is incorrect'));
            }
          } else if (msg.type === 'notInstalled') {
            setShowPopupNice(true);
            reject(new Error('notInstalled'));
          } else {
            reject(new Error('unknouwn event'));
          }
        } catch (e) {
          console.error('Fail to parse message:', e);
          reject(new Error('Fail to parse message:' + e));
        }
      }
      document.addEventListener('message', responseListener, { once: true });
    });
  }

  return (
    (
      pageLoading == 1 ?
        <ParkingClosingSkeleton />
        :
        <>
          <AppInfiniteScroll
            refreshFunction={refreshFunction}
            data={[]}
            hasMore={false}
          >
            <div className={`parking-status-container bg-status-page`} style={{ height: "auto" }}>
              {/* <label class="nh-label">현황</label> */}
              <div className="nl-row j-between col bg-white mb-10 py-10 px-20">
                <div className="sub-header-text w-full">
                  <label className="nh-label">현황</label>
                </div>
              </div>
              <div className="nh-container">
                <div className="bg-white nh-container px-20">
                  <div className="nl-row a-center">
                    <div className="col-6 nh-border-right nh-info">
                      <div className="nh-text-top-left">재차</div>
                      <div className="nh-text-bottom-right">{payCount.unPaidCount || 0} 건</div>
                    </div>
                    <div className="col-6">
                      <div className="nh-text-top-left  nh-info2">선납</div>
                      <div className="nh-text-bottom-right pr-0">{payCount.prePaidCount || 0} 건</div>
                    </div>
                  </div>
                  <div>
                    <div className="htSeparator mb-10"></div>
                    <label className="nh-label mb-10">매출집계</label>
                    {/* <AppInfoRow label="현금" value={("0 원")} /> */}
                    <AppInfoRow label="카드" labelClass="htFontSize16 htColorDark" valueClass="htFontSize16" value={`${numberFormat(totalPayAmount)} 원`} />
                  </div>
                  {
                    payCount.pastUnPaidCount > 0 && <div>
                      <div className="htSeparator mb-10 mt-25"></div>
                      {/* <AppInfoRow label="현금" value={("0 원")} /> */}
                      <AppInfoRow label={`오늘 이전에 입차된 차량이 ${payCount.pastUnPaidCount}대 있습니다. 다시 한 번 확인해 주세요.`} labelClass="htFontSize16 htError" valueClass="htFontSize16" value={""} />
                    </div>
                  }

                  {/* <label class="nh-label">마감실행</label>
            <div className=" bg-white pt-10 pb-10 pl-10 pr-10">
                <button type="button" className="nh-btn-yes mb-15">마감처리</button>
                <button type="button" className="nh-btn-no">마감처리</button>
            </div> */}
                </div>

              </div>



            </div>
          </AppInfiniteScroll>
          {showPopupConfirmUnpaid && (
            <Popup
              title="결제"
              handleYes={() => onUnpaid('today')}
              handleNo={() => setShowPopupConfirmUnpaid(false)}
              textYes="예"
              textNo="아니오"
              setVisible={setShowPopupConfirmUnpaid}
            >
              <div className="nl-row col-12 a-center j-center">
                <div>정말로 마감처리를 진행할까요?</div>
              </div>

            </Popup>
          )}
          {showPopupConfirmUnpaidPast && (
            <Popup
              title="결제"
              // handleYes={() => onUnpaid('past')}
              handleYes={() => setShowPopupConfirmUnpaidPast(false)}
              // handleNo={() => setShowPopupConfirmUnpaidPast(false)}
              textYes="예"
              // textNo="아니오"
              setVisible={setShowPopupConfirmUnpaidPast}
            >
              <div className="nl-row col-12 a-center j-center">
                {/* <div>정말로 마감처리를 진행할까요?</div> */}
                <div>{`오늘 이전에 입차된 차량이 ${payCount.pastUnPaidCount}대 있습니다. 다시 한 번 확인해 주세요.`}</div>
              </div>

            </Popup>
          )}
          {showPopupError && (
            <Popup
              title="결제"
              handleYes={() => setShowPopupError(false)}
              textYes="예"
              setVisible={setShowPopupError}
            >
              <div className="nl-row col-12 a-center j-center">
                <div>오류가 발생했습니다. 다시 시도해 주세요.</div>
              </div>


            </Popup>
          )}
          {showPopupNoData && (
            <Popup
              title="정보"
              handleYes={() => setShowPopupNoData(false)}
              textYes="닫기"
              setVisible={setShowPopupNoData}
            >
              <div className="nl-row col-12 a-center j-center">
                <div>마감할 내용이 없습니다.</div>
              </div>


            </Popup>
          )}
          {showPopupNice && (
              <Popup
                  title="결제"
                  handleYes={() => setShowPopupNice(false)}
                  textYes="예"
                  setVisible={setShowPopupNice}
              >
                <div className="nl-row f-column">
                  <div>NICEPAY 앱을 설치하고 다시 시도해주세요!</div>
                </div>

              </Popup>
          )}
          {showPopupAlert && (
            <Popup
              title="정보"
              handleYes={() => setShowPopupAlert(false)}
              textYes="닫기"
              setVisible={setShowPopupAlert}
            >
              <div className="nl-row col-12 a-center j-center px-15">
                <div>{`마감시간 이후에 일마감을 진행할수 있습니다. 현재시간은 ${currentTime} 이며, 마감시간은 ${closingTime} 입니다.`}</div>
              </div>


            </Popup>
          )}
          {unpaidLoading && (
            <PakingClosingLoading
              loadingProgress={unpaidLoadingProgress}
              showProgress={parkingSpaceUsingList.length >= 2 ? true : false}
            />
          )}
          <ButtonBot
            textYes={"마감처리"}
            textNo={false ? "이전마감" : null}
            handleYes={() => onParkingClosing('today')}
            handleNo={() => onParkingClosing('past')}
          />
        </>
    )
  );
};

export default ParkingClosing;

const ParkingClosingSkeleton = () => {
  return (
    <div className="px-20 py-20 bg-white">
      <div className="mb-4">
        <Skeleton height={40} width={'100%'} />
      </div>
      <div className="flex justify-between mb-4 gap-10">
        <div className="text-center col-6">
          <Skeleton height={20} width={'100%'} />
          <Skeleton height={40} width={'100%'} />
        </div>
        <div className="text-center col-6">
          <Skeleton height={20} width={'100%'} />
          <Skeleton height={40} width={'100%'} />
        </div>
      </div>
      <div className="flex justify-between mb-4 gap-10">
        <div className="text-center col-6">
          <Skeleton height={20} width={'100%'} />
          <Skeleton height={40} width={'100%'} />
        </div>
        <div className="text-center col-6">
          <Skeleton height={20} width={'100%'} />
          <Skeleton height={40} width={'100%'} />
        </div>
      </div>
    </div>
  );
};

const PakingClosingLoading = ({
  loadingProgress = 0,
  showProgress = false,
}) => {
  return (
    <div className="htLoading">
      <RotatingLines
        visible={true}
        height="60"
        width="60"
        color="grey"
        strokeWidth="5"
        animationDuration="1.4"
        ariaLabel="rotating-lines-loading"
        wrapperStyle={{}}
        wrapperClass=""


      />
      {showProgress && <div className="htLoadingText">{loadingProgress}</div>}
    </div>
  );
}
